import React, { FC } from 'react';
import { useMedia } from 'react-use';
import { isMobile, isTablet } from 'react-device-detect';
import { MobileView, DesktopView, TabletView } from 'pages/vehicle-documents/components/views';
import { VehicleDocumentsBodyProps } from './vehicle-documents-body.types';

export const VehicleDocumentsBody: FC<VehicleDocumentsBodyProps> = ({ data, ...others }) => {
  const isWide = useMedia('(max-width: 800px)');
  const props = { detailInfo: data, ...others };

  if (isTablet) {
    return <TabletView {...props} />;
  }

  if (isMobile || isWide) {
    return (
      <div className="mb-4">
        <MobileView {...props} />
      </div>
    );
  }

  return <DesktopView {...props} />;
};
